<template>
  <div class="fs-form fs-slider">
    <div class="fs-back" v-if="routerLink">
      <router-link :to="routerLink ? routerLink : '/'" class="mi">arrow_back</router-link>
    </div>
    <fs-range :min="min" :max="max" :defaultValue="defaultValue" :label="label" :disabled="disabled" :value="value" v-model="valueModel"></fs-range>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
class FsRangeFilterWrapper extends Vue {

  @Prop()
  private value: number;

  @Prop()
  private min: number;

  @Prop()
  private max: number;

  @Prop()
  private defaultValue: number;

  @Prop()
  private label: string;

  @Prop()
  private disabled: boolean;

  @Prop()
  private routerLink: string;

  get valueModel(): number {
    return this.value || 0;
  }

  set valueModel(val) {
    this.$emit('input', +val);
  }
}

export default FsRangeFilterWrapper;
</script>
